import { ExtendedDocument } from 'types/DocumentsTypes/Document';

// Generalized function to create mock documents
export const createMockDocument = (type: string, status: string = 'pending_approval'): ExtendedDocument => {
    return {
        id: 100766,
        entId: '396',
        entName: 'Mock Customer',
        entBName: 'Mock Business',
        date: new Date(),
        end: new Date(),
        issueDate: new Date(),
        type,
        status,
        agent: 'Mock Agent',
        mainValue: Math.floor(Math.random() * 5000) + 1000,
        taxValue: 17,
        ref_id: `REF-${Math.floor(Math.random() * 9999)}`,
        nkObject: {
            someProperty: 'value',
            signData: () => ({
                date: new Date().toISOString(),
                signer: 'Mock Signer'
            }),
            getConnectedDocType: () => type,
            getConnectedOrder: () => ({
                orderId: Math.floor(Math.random() * 5000),
                orderDate: new Date().toISOString(),
                getKartonString: () => 'Mock Karton String',
                isCollected: (productId: number) => true
            }),
            getKartonString: () => 'Mock Karton String',
            ...(type === 'visit_note'
                ? {
                      getConnectedValue: () => 500,
                      getAmounts: () => 5,
                      getConnectedPayment: () => 400
                  }
                : {})
        },

        comment: `Mock comment for ${type}`,
        category: 'Finance',
        sign: type === 'tax_invoice' || type === 'invoice',
        photo: type === 'delivery_certificate',
        pdf: true,
        color: '#ffcc00',
        textColor: '#000000',
        baseColor: '#ffffff',
        description: `Mock description for ${type}`,
        title: `תעודה לדוגמא - ${type}`,
        name: `Mock ${type}`,
        allDay: false,
        notvalid: false,
        storeNext: null,
        hashavshevet: null,
        manager: null,
        one: null,
        driver: 'Mock Driver',
        orderId: Math.floor(Math.random() * 5000),
        agent_id: Math.floor(Math.random() * 999),
        notes2: 'Additional note 2',
        notes3: 'Additional note 3',
        notes4: 'Additional note 4',
        notes5: 'Additional note 5',
        taxConfirmation: type === 'tax_invoice' || type === 'invoice' ? 'TAX-1234' : null,
        details: {
            street: '123 Mock St',
            streetNumber: '45A',
            companyName: 'Mock Business Ltd.',
            companyId: '123456789',
            phone: '123-456-7890',
            email: 'mock@business.com',
            name: 'Mock Customer'
        },

        states: type === 'visit_note' ? ['Checked stock', 'Discussed pricing', 'Scheduled follow-up'] : [],

        payments:
            type === 'tax_invoice' || type === 'invoice'
                ? [
                      {
                          id: 1,
                          method: 'credit',
                          amount: 2500,
                          check: null
                      },
                      {
                          id: 2,
                          method: 'cash',
                          amount: 500,
                          check: null
                      }
                  ]
                : [],

        handArray:
            type === 'tax_invoice' || type === 'invoice'
                ? [
                      { description: 'Manual Entry 1', amount: 1, value: 100 },
                      { description: 'Manual Entry 2', amount: 2, value: 200 }
                  ]
                : [],

        deliveryCertificatesIds: type === 'tax_invoice' ? ['DEL-001', 'DEL-002'] : [],

        discount: 5,
        preValue: 2800,
        mainValue: 3000,
        taxValue: 200,
        comment: 'This is a sample document comment.',

        products:
            type === 'tax_invoice' || type === 'invoice'
                ? [
                      {
                          id: 101,
                          external_id: 'PROD-101',
                          name: 'Product A',
                          barcode: '111222333',
                          costPrice: 100,
                          position: 1,
                          quantity: 3,
                          quantitySecond: 0,
                          quantityReturns: 0,
                          available_units: ['Unit'],
                          conversion_ratio: 1,
                          discount: 0,
                          totalPrice: 300,
                          notes: 'Mock product note'
                      },
                      {
                          id: 102,
                          external_id: 'PROD-102',
                          name: 'Product B',
                          barcode: '444555666',
                          costPrice: 200,
                          position: 2,
                          quantity: 2,
                          quantitySecond: 0,
                          quantityReturns: 0,
                          available_units: ['Unit'],
                          conversion_ratio: 1,
                          discount: 0,
                          totalPrice: 400,
                          notes: 'Another mock product'
                      }
                  ]
                : []
    };
};

// ✅ Predefined mock documents
export const mockDeliveryCertificate = createMockDocument('delivery_certificate', 'pending_approval');
export const mockTaxInvoice = createMockDocument('tax_invoice', 'approved');
export const mockReceipt = createMockDocument('receipt', 'open');

// ✅ New mocks for additional views
export const mockInvoice = createMockDocument('invoice', 'approved'); // InvoicePreview
export const mockDebt = createMockDocument('debt', 'pending'); // DebtPreview
export const mockVisitNote = createMockDocument('visit_note', 'open'); // VisitPreview
